import React from 'react';
import JavascriptWebApiIntro from './JavascriptWebApiIntro.jsx';
import JavascriptWebApiValidation from './JavascriptWebApiValidation.jsx';
import JavascriptWebApiHistory from './JavascriptWebApiHistory.jsx';
import JavascriptWebApiStorage from './JavascriptWebApiStorage.jsx';
import JavascriptWebApiWorker from './JavascriptWebApiWorker.jsx';
import JavascriptWebApiFetch from './JavascriptWebApiFetch.jsx';
import JavascriptWebApiGeolocation from './JavascriptWebApiGeolocation.jsx';

export default function JsWebApis() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Web APIs</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/web-api/intro' className='underline'>Web API Intro</a></li>
<li><a href='/javascript/web-api/validation' className='underline'>Web Validation API</a></li>
<li><a href='/javascript/web-api/history' className='underline'>Web History API</a></li>
<li><a href='/javascript/web-api/storage' className='underline'>Web Storage API</a></li>
<li><a href='/javascript/web-api/worker' className='underline'>Web Worker API</a></li>
<li><a href='/javascript/web-api/fetch' className='underline'>Web Fetch API</a></li>
<li><a href='/javascript/web-api/geolocation' className='underline'>Web Geolocation API</a></li>
      </ul>
    </div>
  );
}
